var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from "react";
export const useGroupedFeatures = (features) => {
    const groupedFeatures = useMemo(() => {
        const grouped = [];
        const sectionMap = {};
        features.forEach((feature) => {
            var _a, _b;
            const { section_i18n_title } = feature, rest = __rest(feature, ["section_i18n_title"]);
            if (section_i18n_title) {
                if (!sectionMap[section_i18n_title]) {
                    sectionMap[section_i18n_title] = {
                        title: section_i18n_title,
                        disposition: rest.disposition,
                        icon: (_a = rest.section_icon) !== null && _a !== void 0 ? _a : "",
                        items: [],
                        name: section_i18n_title,
                        childItemIsActive: false,
                    };
                    grouped.push(sectionMap[section_i18n_title]);
                }
                sectionMap[section_i18n_title].childItemIsActive =
                    sectionMap[section_i18n_title].childItemIsActive ||
                        ((_b = rest.isActive) !== null && _b !== void 0 ? _b : false);
                sectionMap[section_i18n_title].items.push(rest);
            }
            else {
                grouped.push(rest);
            }
        });
        return grouped.map((item) => {
            if ("items" in item && item.items.length === 1) {
                return item.items[0];
            }
            return item;
        });
    }, [features]);
    return groupedFeatures;
};
//# sourceMappingURL=groupFeaturesBySection.js.map